var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Sidebar"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13",
    x: 2,
    y: 2,
    width: 4,
    height: 20,
    rx: 2,
    fill: "#353C43"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14",
    opacity: 0.4,
    x: 8,
    y: 2,
    width: 14,
    height: 20,
    rx: 3,
    fill: "#353C43"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarToggle);
export default __webpack_public_path__ + "static/media/sidebar_toggle.945e5df119b8615a69483238331eacc0.svg";
export { ForwardRef as ReactComponent };